import { type ReactNode, useState } from 'react';

import { PracticeArea } from '../../../../backend/src/user/practice-area';
import { useUpdateOwnPracticeArea } from '@/api/mutations/useUpdateOwnPracticeArea';
import { useUserContext } from '@/Contexts/User';
import { Icon } from '@/new/components/icon';
import { PracticeAreaSelect } from '@/new/components/practice-area-select';
import { Button } from '@/new/components/shadcn/button';
import { Label } from '@/new/components/shadcn/label';

export function PracticeAreaGate({ children }: { children: ReactNode }) {
  const { user } = useUserContext();
  const [practiceArea, setPracticeArea] = useState<PracticeArea | null>(null);
  const updatePracticeArea = useUpdateOwnPracticeArea();

  if (!user) return null;

  const isRequired = user.organisation?.requirePracticeArea === true && !user.practiceArea;
  if (!isRequired || user.termsAcceptanceRequired === true) return children;

  return (
    <main className="flex min-h-screen w-full items-center justify-center bg-white px-6 py-12">
      <div className="w-full max-w-md">
        <div className="px-3">
          <h1 className="text-2xl text-gray-800">Choose your practice area</h1>
          <p className="mt-2.5 text-sm text-gray-600">
            Your organisation requires you to select a practice area before you can continue to Wexler.
          </p>
        </div>

        <div className="mt-8">
          <Label className="mb-3 px-3 text-gray-700" htmlFor="practice-area">
            Practice area
          </Label>
          <PracticeAreaSelect
            id="practice-area"
            value={practiceArea}
            onValueChange={setPracticeArea}
            className="w-full"
          />
        </div>

        <div className="flex justify-end">
          <Button
            className="mt-5"
            disabled={!practiceArea || updatePracticeArea.isLoading}
            onClick={() => practiceArea && updatePracticeArea.mutate(practiceArea)}
          >
            Continue to Wexler
            <Icon
              className={
                updatePracticeArea.isLoading ? 'lucide--loader animate-spin ease-in-out' : 'lucide--chevron-right'
              }
            />
          </Button>
        </div>
      </div>
    </main>
  );
}
